import i18n from '@/lib/i18n';
import { useAccountStore } from '@/store/use-account-store';
import { useOrdersStore } from '@/store/use-orders-store';
import { useTranslation } from 'react-i18next';

type Props = {
  orderId: string;
};

export default function ReduceOnly({ orderId }: Props) {
  const { t } = useTranslation();
  const address = useAccountStore((state) => state.address);
  const reduceOnly = useOrdersStore(
    (state) => state.getOrders(address).orders[orderId].reduceOnly,
  );
  return reduceOnly ? t('openOrdersTable.yes') : t('openOrdersTable.no');
}

export const reduceOnlyAccessorFn = (id: string) => {
  const { address } = useAccountStore.getState();
  const { reduceOnly } = useOrdersStore.getState().getOrders(address).orders[
    id
  ];
  return i18n.t(reduceOnly ? 'openOrdersTable.yes' : 'openOrdersTable.no');
};
